import React, { useState } from "react";
import { CabeceraTable } from "../../../../components/Table/CabeceraTable";
import { IColumn, ICommandBarItemProps, Icon, Stack, TooltipHost, mergeStyleSets } from "@fluentui/react";
import { TableBase2 } from "../../../../components/Table/TableBase2";
import { PaginationFooterC } from "../../../../components/PaginationFooter/PaginationFooterC";
import IconHelper from "../../../../utils/helpers/iconHelper";
import { useTableIpercEquipo } from "../../../../hooks/TablasHooks/useTableIpercEquipo";
import { useBoolean } from "@fluentui/react-hooks";
import { PanelActualizarEquipoIperc } from "./PanelActualizarEquipoIperc";
import { IActualizarEquipoIperc } from "../../../../Interfaces/IPERC/IEquipo";
import { PanelCrearEquipoIperc } from "./PanelCrearEquipoIperc";
import { PanelActividadesPorEquipo } from "./PanelActividadesPorEquipo";

const classNames = mergeStyleSets({
  iconFont: {
    padding: 0,
    fontSize: "16px",
    marginRight: 5,
  },
});

export const ConfiguracionEquiposIperc = () => {

  const [selectedEquipo, setSelectedEquipo] = useState("");
  const [isOpenPanelActividades, { setTrue: openPanelActividades, setFalse: dismissPanelActividades }] =
    useBoolean(false);

  const [isOPenPanel, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);
  const {
    _onkeyUpSearch,
    dataTeble,
    loading,
    onChangeSkip,
    onClickRefresh,
    paginacion,
    searchBoxRefTable,
  } = useTableIpercEquipo();

  const _itemsLeft: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_ADD,
      onClick: () => {
        openPanel();
      },
    },
    {
      ...IconHelper.ICON_RELOAD,
      onClick: () => {
        onClickRefresh();
      },
    },
  ];
  const [
    isOpenPanelEditEquipo,
    { setTrue: openPanelEditEquipo, setFalse: onDismissPanelEditEquipo },
  ] = useBoolean(false);

  const [modelActualizarEquipo, setModelActualizarEquipo] =
    useState<IActualizarEquipoIperc>({
      EquipoId: "",
      Nombre: ""
    });

  const column: IColumn[] = [
    {
      key: "equipo",
      name: "Equipo",
      fieldName: "nombre",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "proceso",
      name: "Proceso",
      fieldName: "nombreProceso",
      minWidth: 300,
      maxWidth: 300,
      isResizable: true,
    },
    {
      key: "fechaCreado",
      name: "Fecha de creación",
      fieldName: "fechaCreado",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      fieldName: "opciones",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
      isCollapsible: true,
      data: "number",
      onRender: (item) => (
        <>
          <TooltipHost content={"Editar"}>
            <Icon
              iconName="edit"
              className={classNames.iconFont}
              style={{ cursor: "pointer", color: "black" }}
              onClick={() => {
                setModelActualizarEquipo({
                  ...modelActualizarEquipo,
                  EquipoId: item.equipoId,
                  Nombre: item.nombre
                });
                openPanelEditEquipo();
              }}
            />
          </TooltipHost>
          <TooltipHost content={"Actividades"}>
            <Icon
              iconName="GroupedList"
              className={classNames.iconFont}
              style={{ cursor: "pointer", color: "black" }}
              onClick={() => {
                //   toggleHideDialog2();
                setSelectedEquipo(item.equipoId);
                openPanelActividades();
                // LoadData2(item.ubicacionId);
                // setmodel({ ...model, ubicacionId: item.ubicacionId });
              }}
            />
          </TooltipHost>
        </>
      ),
    },

  ];


  return (
    <>
      <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg12">
          <CabeceraTable
            placeholder="Buscar Por Nombre"
            componentRef={searchBoxRefTable}
            Titulo="Equipos"
            SubTitulo="Gestión de Equipo"
            onKeyUp={_onkeyUpSearch}
          />
        </div>
      </div>
      <br />
      <Stack>
        <TableBase2
          leftBar={_itemsLeft}
          data={dataTeble}
          column={column}
          isLoading={loading}
          footerPagination={
            <PaginationFooterC
              paginacion={paginacion}
              onChangePagina={(e) => {
                onChangeSkip(e);
              }}
            />
          }
        />
      </Stack>
      <PanelActualizarEquipoIperc
        isOpen={isOpenPanelEditEquipo}
        onDismiss={onDismissPanelEditEquipo}
        modelActualizarEquipo={modelActualizarEquipo}
        onRefreshTable={onClickRefresh}
      />
      <PanelCrearEquipoIperc
        isOpen={isOPenPanel}
        onDismiss={dismissPanel}
        onRefreshTable={onClickRefresh}
      />
      <PanelActividadesPorEquipo
        isOpen={isOpenPanelActividades}
        onDismiss={dismissPanelActividades}
        equipoId={selectedEquipo}
        onRefreshTable={onClickRefresh}
      />

    </>
  );
};
